import React from "react";
import { useNavigate } from "react-router-dom";
import "./reports.css";

const cards = [
  {
    title: "Analytics Dashboard",
    path: "/reports/dashboard",
    // desc: "Visual analytics dashboard for collections, channels, contribution types and top Jumuia.",
  },
  {
    title: "Transaction Report",
    path: "/reports/transactions",
    // desc: "Detailed transaction report with date, channel, contribution and hierarchy filters.",
  },
  {
    title: "Member Register Report",
    path: "/reports/members",
    // desc: "Detailed member report with gender, marital status, age group and hierarchy filters.",
  },
  {
    title: "Contribution Summary",
    path: "/reports/contribution-summary",
    // desc: "Summary report grouped by contribution types.",
  },
  {
    title: "Channel Summary",
    path: "/reports/channel-summary",
    // desc: "Summary report grouped by payment channel.",
  },
  {
    title: "Cashier Report",
    path: "/reports/cashier-report",
    // desc: "Report grouped by cashier signature / posted by.",
  },
];

export default function ReportsHome() {
  const navigate = useNavigate();

  return (
    <div className="page-container">
      <div className="reports-header">
        <div>
          <h1>Reports</h1>
          {/* <p className="subtitle">
            Enterprise reports and analytics for your Parokia
          </p> */}
        </div>
      </div>

      <div className="reports-home-grid">
        {cards.map((card) => (
          <div key={card.path} className="card reports-home-card">
            <h3>{card.title}</h3>
            <p className="subtitle">{card.desc}</p>
            <button className="btn primary" onClick={() => navigate(card.path)}>
              Open Report
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}